import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { assignOfficesToDso, getOfficeById } from '../../../../../actions/dsosActions';
import { AssignDso } from '../../../StaffDetails/components/tabs/GeneralTab/components';

export const DsoName = ({ officeId }) => {
  const dispatch = useDispatch();
  const office = useSelector((state) => state.dsos.office);

  useEffect(() => {
    dispatch(getOfficeById(officeId));
  }, [dispatch, officeId]);

  const handleSaveButton = (selectedOption) => {
    if (!selectedOption?.id) {
      return;
    }

    dispatch(
      assignOfficesToDso({
        dsoId: selectedOption.id,
        dsoLabel: selectedOption.label,
        officesIds: [officeId],
      }),
    );
  };

  return (
    <AssignDso
      value={{
        id: office?.dso?.id,
        label: office?.dso?.name,
      }}
      onSave={handleSaveButton}
      showUnlinkFromOfficeButton
    />
  );
};
